// extracted by mini-css-extract-plugin
export default {"mainBox":"AdminSettings_mainBox__MyPgN","footerBox":"AdminSettings_footerBox__QrYbi"};